module.exports = __webpack_public_path__ + "static/img/mine_feedback@3x.c32e77d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine_feedback@3x.png
// module id = VIQP
// module chunks = 1